module.exports = __webpack_public_path__ + "img/LogoCustosMobile_Color.424be679.png";